export const TIMEOUT_IN_MS = 2000
